export default function initContentHubArchiveFilters($) {
  const QUERY_URL = 'getContentHubArchivePages';

  let page = 1;
  let selected_filters = {};
  let secondary_parameters = {};

  function addParamsToUrl() {
    const url = new URL(window.location.href.replace(/(\?.*)/, ''));
    if (!$.isEmptyObject(secondary_parameters)) {
      $.each(secondary_parameters, function (key, value) {
        url.searchParams.set(key, value);
      });
    }
    $.each(selected_filters, function (key, value) {
      url.searchParams.set(key, value);
    });
    history.pushState('', '', url);
  }

  function duplicateSelectionToDesktop(selectedOption) {
    const selected_tag = $(selectedOption).find(':selected');
    const data_id = selected_tag.data('tag-id');
    const filter_id = selected_tag.parent().data('filter-id');
    const $filterTags = $(
      `.mck-content-hub-archive-filters .filter[data-filter-id="${filter_id}"] .filter-tag`,
    );
    $filterTags.each((i, el) => {
      if ($(el).data('tag-id') === data_id) {
        $(el).addClass('selected');
      } else {
        $(el).removeClass('selected');
      }
    });
  }

  function duplicateSelectionToMobile(selectedFilter) {
    const filterId = $(selectedFilter)
      .parents('[data-filter-id]')
      .data('filter-id');
    const selectedFilterId = $(selectedFilter).data('tag-id');
    $('#mobile-filters select').each((index, element) => {
      if (element.dataset.filterId.indexOf(filterId) >= 0) {
        $(element)
          .children()
          .each((i, el) => {
            el.selected = false;
          });
        $(element).find(`[data-tag-id="${selectedFilterId}"]`)[0].selected =
          true;
      }
    });
  }

  function updateLinksClass() {
    $('a').each(function () {
      if (
        !$(this).attr('href').startsWith('/') &&
        !$(this).attr('href').startsWith('mail') &&
        !$(this).attr('href').startsWith('javascript') &&
        !$(this).attr('href') == '#'
      ) {
        $(this).addClass('CTAExternal');
      }
    });
  }

  function getSelectedFilters(origin) {
    'tags' === origin
      ? $('.filter-tag.selected').each((index, element) => {
          const data_id = $(element).data('tag-id');
          const filter_id = $(element).parent().data('filter-id');
          selected_filters[constructFilterId(filter_id)] = data_id;
          if ($('.filter-tag.selected').length === index + 1) {
            page = 0;
            addParamsToUrl();
            BindStoriesArchive(page);
          }
        })
      : $('.select-filter').each(function (index) {
          const selected_tag = $(this).find(':selected');
          const data_id = selected_tag.data('tag-id');
          const filter_id = selected_tag.parent().data('filter-id');
          selected_filters[constructFilterId(filter_id)] = data_id;
          if ($('.select-filter').length === index + 1) {
            page = 0;
            addParamsToUrl();
            BindStoriesArchive(page);
          }
        });
  }

  function getFiltersFromUrl(k) {
    let p = {};
    location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
      p[k] = v;
    });
    return k ? p[k] : p;
  }

  $('.filter-tag').on('click', function () {
    if (!$(this).hasClass('selected')) {
      $(this).parent().find('.filter-tag.selected').removeClass('selected');
      $(this).addClass('selected');
      getSelectedFilters('tags');
    }

    duplicateSelectionToMobile(this);

    setTimeout(function () {
      updateLinksClass();
    }, 1000);
    setTimeout(function () {
      updateLinksClass();
    }, 2000);
  });

  $('.select-filter').on('change', function (e) {
    duplicateSelectionToDesktop(this);
    getSelectedFilters('select');
  });

  function showMore() {
    $('.mck-hub-archive-show-more-js').on('click', (e) => {
      e.preventDefault();
      const $link = $(e.currentTarget);
      const nextPage = $link.data('page');

      setTimeout(function () {
        $('a').each(function () {
          if (
            !$(this).attr('href').startsWith('/') &&
            !$(this).attr('href').startsWith('mail')
          ) {
            $(this).addClass('CTAExternal');
          }
        });
      }, 1000);

      BindStoriesArchive(nextPage, true);
    });
  }

  const mergeThumbHtml = (oldHtml, newHtml) => {
    const $oldHtml = $(document.createElement('div'));
    const $newHtml = $(document.createElement('div'));
    $newHtml.append(newHtml);
    $oldHtml.append(oldHtml);
    const $newThumbsAndButton = $(document.createElement('div'));
    const thumbsAndButton = $newHtml.find('.section.listing.feed')[0].outerHTML;
    const oldThumbs = $oldHtml.find('#our-stories-feed')[0].innerHTML;
    $newThumbsAndButton.html(thumbsAndButton);
    $newThumbsAndButton.find('#our-stories-feed').prepend(oldThumbs);
    return $newThumbsAndButton.find('.section.listing.feed')[0].innerHTML;
  };

  function BindStoriesArchive(page, load_more) {
      $('.noresultsmessage').hide();
    const requestData = JSON.stringify({
        filters: selected_filters,
        page: page,
    });

    let dataUrl = `${window.location.pathname}/${QUERY_URL}`;
    dataUrl = dataUrl.replace('//', '/');

    $.ajax({
      type: 'POST',
      url: dataUrl,
      data: requestData,
      contentType: 'application/json; charset=utf-8',
      dataType: 'html',
      success: function (response) {
        $('.mck-press-releases-loading-js').hide();
        try {
          if (load_more) {
            const oldHtml = $('#our-stories-archives').html();
            const mergedHtml = mergeThumbHtml(oldHtml, response);
            $('#our-stories-archives .section.listing.feed').html(mergedHtml);
          } else {
              const $response = $(response);
              const totalRecordsValue = $response.find('#totalRecords').val();

              if (parseInt(totalRecordsValue) == 0) {
                  $('#our-stories-archives').hide();
                  var keyvaluepairarray = []
                  var obj = {};
                  var index = 0;
                  $('select').each(function () {
                      obj = { key: $("#RootCategory_" + index).val(), value: $(this).find('option:selected').text(), id: $(this).find('option:selected').val(), Parentid: $(this).attr('id') }
                      keyvaluepairarray.push(obj);
                      index++;
                  });
                  
                  keyvaluepairarray.forEach(function (pair) {
                      var keyRegex = new RegExp(pair.key, 'g');
                      $response.html($response.html().replace(keyRegex, pair.value));
                  });

                  $('#our-stories-archives').replaceWith($response);
              }
              else {
                  $('#our-stories-archives').replaceWith(response);
              }
            
          }

          showMore();
        } catch (ex) {}
      },
      failure: function (response) {
        $('.mck-press-releases-loading-js').hide();
        alert(response);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        let errMessage =
          'An error occurred serving your request. Please try again.';
        jqXHR && (errMessage = $.parseJSON(jqXHR.responseText).Message);
        $('.mck-press-releases-loading-js').hide();
        alert(errMessage);
      },
    });
    }

    const constructFilterId = (rootCategoryId) => 
        `filter_id${rootCategoryId}`

  $(() => {
    if ($('body').hasClass('content-hub')) {
      $('.our-stories-header').length > 0 && setHeaderHeight();
    }

      const filtersContainer = document.querySelector(".mck-content-hub-archive-filters");

      if (filtersContainer) {
          selected_filters = getFiltersFromUrl();
          for (let p in selected_filters)
              if (!/^filter/.test(p))
                  delete selected_filters[p];
          filtersContainer.querySelectorAll('.filter-tags ul.filter')?.forEach(x => {
              const filterId = selected_filters[constructFilterId(x.dataset.filterId)] || 1;
              x.querySelector(`li.filter-tag[data-tag-id='${filterId}']`).classList.add("selected");
          });

          filtersContainer.querySelectorAll('select.select-filter')?.forEach(x => {
              const filterId = selected_filters[constructFilterId(x.dataset.filterId)] || 1;
              x.querySelector(`option[data-tag-id='${filterId}']`).selected = true;
          });

          showMore();
          BindStoriesArchive(0);
      }
  });

  window.BindStoriesArchive = BindStoriesArchive;
}
